import { render, staticRenderFns } from "./CustomerDob.vue?vue&type=template&id=1735664c&"
import script from "./CustomerDob.vue?vue&type=script&lang=ts&"
export * from "./CustomerDob.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports